<template>
  <div>
    <div style="text-align: center">
      <h3>Action</h3>
    </div>
    <br />
    <label for="">Dari</label>
    <v-date-picker class="inline-block h-full" v-model="form.date_from" mode="date">
      <template v-slot="{ inputValue, togglePopover }">
        <div>
          <input @focus="togglePopover()" :value="inputValue" class="form-control" />
        </div>
      </template>
    </v-date-picker>
    <br>
    <label for="">Sampai</label>
    <v-date-picker class="inline-block h-full" v-model="form.date_to" mode="date">
      <template v-slot="{ inputValue, togglePopover }">
        <div>
          <input @focus="togglePopover()" :value="inputValue" class="form-control" />
        </div>
      </template>
    </v-date-picker>
    <br>
    <button v-on:click="deleteAllBlastList" type="button" class="btn btn-block btn-danger text-white">Hapus Semua
      Blast List</button>
    <button v-on:click="deleteInactiveBlastList" type="button" class="btn btn-block btn-danger text-white">Hapus Semua Blast List
      Inactive</button>
    <button v-on:click="deleteDraftBlastList" type="button" class="btn btn-block btn-danger text-white">Hapus Semua
      Blast List Draft</button>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data() {
      return {
        form: {
          date_from: new Date(),
          date_to: new Date()
        },
      };
    },
    mounted() {

    },
    methods: {
      formatDateToUnix() {
        let date1 = moment(this.form.date_from).format("YYYY-MM-DD 00:00:00")
        let date2 = moment(this.form.date_to).format("YYYY-MM-DD 23:59:59")

        let date_from = parseInt(moment(moment(date1).utc().format("YYYY-MM-DD HH:mm:ss")).valueOf())
        let date_to = parseInt(moment(moment(date2).utc().format("YYYY-MM-DD HH:mm:ss")).valueOf())

        return {
          date_from,
          date_to
        }
      },
      async deleteAllBlastList() {
        try {
          let date = await this.formatDateToUnix()
          let response = await this.$store.dispatch('blast_list_delete_all', date)
          this.$toast.success(response.data.message)
          this.$root.$emit("toggle_modal", "action_blast_list")
          this.$root.$emit("refresh_table", true)
        } catch (err) {
          console.log(err)
          this.$toast.error(err.response.data.message);
        }
      },
      async deleteInactiveBlastList() {
        try {
          let date = await this.formatDateToUnix()
          let response = await this.$store.dispatch('blast_list_delete_inactive', date)
          this.$toast.success(response.data.message)
          this.$root.$emit("toggle_modal", "action_blast_list")
          this.$root.$emit("refresh_table", true)
        } catch (err) {
          console.log(err)
          this.$toast.error(err.response.data.message);
        }
      },
      async deleteDraftBlastList() {
        try {
          let date = await this.formatDateToUnix()
          let response = await this.$store.dispatch('blast_list_delete_draft', date)
          this.$toast.success(response.data.message)
          this.$root.$emit("toggle_modal", "action_blast_list")
          this.$root.$emit("refresh_table", true)
        } catch (err) {
          console.log(err)
          this.$toast.error(err.response.data.message);
        }
      },
    },
  };
</script>

